<template>
  <v-sheet v-if="availableVersion" class="version-update-banner ma-3" rounded="lg" elevation="6">
    <v-alert type="info" variant="tonal" density="compact" role="status" aria-live="polite">
      <div class="text-high-emphasis">
        <div class="font-weight-bold">{{ translate('parcours.app.versionUpdateBanner.newVersionAvailable') }}</div>
        <div v-if="alreadyReloaded">{{ translate('parcours.app.versionUpdateBanner.updateNotYetOnServer') }}</div>
        <template v-else>
          <div>{{ translate('parcours.app.versionUpdateBanner.finishOperations') }}</div>
          <div v-if="reloadFailed" class="mt-1">{{ translate('parcours.app.versionUpdateBanner.reloadUnavailable') }}</div>
          <v-btn class="mt-2" color="primary" variant="flat" :loading="reloading" @click="reload">
            {{ translate('parcours.app.versionUpdateBanner.reload') }}
          </v-btn>
        </template>
      </div>
    </v-alert>
  </v-sheet>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { translate, useSdk } from '@fondationcss/sdk';
import { createVersionGuard } from '@/version-guard';

const sdk = useSdk();
const guard = createVersionGuard({
  version: __APP_VERSION__,
  enabled: import.meta.env.PROD,
  apiUrl: () => sdk.settings.value?.apiUrl || import.meta.env.VITE_API_URL || '/api',
  appBaseUrl: import.meta.env.BASE_URL,
});
const { availableVersion, reloading, reloadFailed, alreadyReloaded, reload } = guard;
onMounted(guard.start);
onUnmounted(guard.stop);
</script>

<style scoped>
.version-update-banner {
  position: fixed;
  bottom: 0;
  right: 0;
  max-width: min(32rem, calc(100vw - 24px));
  /* Below dialogs: a demo apply or an attendance editor keeps focus until it closes. */
  z-index: 1000;
}
</style>
